module.exports = __webpack_public_path__ + "static/img/sharepage-retain.c1eb911a.png";